import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        showDrawer: true,
        loginUser: {}
    },
    mutations: {
        setShowDrawer(state, data) {
            state.showDrawer = data
        },
        setLoginUser(state, data) {
            state.loginUser = data
        }
    },
    actions: {
        commitShowDrawer: ({commit}, showDrawer) => commit('setShowDrawer', showDrawer),
        commitLoginUser: ({commit}, loginUser) => commit('setLoginUser', loginUser)
    }
});